import * as React from "react";
const SvgCheckboxEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 8.5, y: 8.5, width: 15, height: 15, rx: 1.5, stroke: "#676B77" }));
export default SvgCheckboxEmpty;
